import { Drawer } from 'antd';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import ChangePrice from './ChangePrice/ChangePrice';
import classes from './Help.module.scss';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
import ArrowIcon from '@/icons/arrow-2.svg';
import CloseIcon from '@/icons/close.svg';
const Help = () => {
    const [selectedForm, setSelectedForm] = useState(null);
    const intl = useIntl();
    const { visibility, defaultValues } = useAppSelector((state) => state.trips.modals.changePrice);
    const { setTripsPopup } = useAppDispatch();
    const { tripId, date, currency, complaint } = defaultValues;
    const onClosePopup = () => {
        setTripsPopup('changePrice', false);
        setSelectedForm(null);
    };
    return (React.createElement(Drawer, { placement: 'bottom', closable: false, onClose: onClosePopup, open: visibility, height: "auto" },
        React.createElement("button", { onClick: onClosePopup, className: classes.close },
            React.createElement(CloseIcon, { width: 20, height: 20 })),
        selectedForm && React.createElement("div", { className: classes.back, onClick: () => { setSelectedForm(null); } },
            React.createElement(ArrowIcon, { style: { transform: 'scaleX(-1)' }, width: 8, height: 16 }),
            " Back"),
        !selectedForm && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.head },
                React.createElement("div", { className: classes.title }, intl.formatMessage({ id: 'web.officeTrips.reportProblem', defaultMessage: 'Report a problem' }))),
            date && React.createElement("div", { className: classes.date }, date),
            React.createElement("div", { className: classes.actions },
                React.createElement("div", { className: classes.actionsItem, onClick: () => { setSelectedForm('change_price'); } },
                    React.createElement("div", { className: classes.actionsItemInner }, intl.formatMessage({ id: 'web.officeTrips.clientPaidDifferentAmount', defaultMessage: 'The client paid a different amount' })),
                    React.createElement("div", { className: classes.actionsItemArrow },
                        React.createElement(ArrowIcon, { width: 6, height: 12 })))))),
        selectedForm === 'change_price' && (React.createElement(ChangePrice, { tripId: tripId, currency: currency, onClosePopup: onClosePopup, complaint: complaint }))));
};
export default Help;
